import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ConnectedLogin from "../manage/Login";
import HeaderNav from "../HeaderNav";
import { checkToken } from "../../redux/actions/usersActions";
import { useTranslation } from 'react-i18next';

function SupportEntry({ user, match, checkSession }) {
  const { t: tr } = useTranslation();
  const guest = !user || user.role === "GUEST";
  useEffect(() => {
    if (guest) checkSession();
  }, [guest, checkSession]);
  const { schoolId, reportId } = match.params;
  if (guest) {
    return (
      <>
        <HeaderNav />
        <div className="fixed-header-page container">
          <h1 className="h4">{tr("manage:integratedText0")}</h1>
          <ConnectedLogin />
        </div>
      </>
    );
  }
  const base = user.role === "CLIENT" ? "/client/support" : "/manage/support";
  return (
    <Redirect
      to={`${base}/${encodeURIComponent(reportId)}?school=${encodeURIComponent(schoolId)}`}
    />
  );
}
SupportEntry.propTypes = {
  user: PropTypes.object,
  match: PropTypes.object.isRequired,
  checkSession: PropTypes.func.isRequired,
};
SupportEntry.defaultProps = { user: null };
export default connect((state) => ({ user: state.user }), {
  checkSession: checkToken,
})(SupportEntry);
